import {Message, Menu, Empty, Card, Divider, Typography, Button} from '@arco-design/web-react';
import styles from "./index.module.less"
import {Author,Helper} from "../index";
import {get} from "../../utils/request";
import {getQuery} from "../../utils";
import { useState,useEffect } from "react";
import {post as store,userSelf} from "../../store";
import { observer } from "mobx-react-lite"
import {IconLink} from "@arco-design/web-react/icon";
import {useNavigate} from "react-router-dom";
import {trackView} from "../../utils/tracker";

export default observer(function ({text,url,post,scene,isSearchResult=false}){
    const [imgFail,setImgFail]=useState(false)
    const navigate=useNavigate()
    const handleSourceClick=async (e)=>{
        e.stopPropagation()
        if(!userSelf.isLogin){
            Message.info('请登录后查看原文。')
            setTimeout(()=>{
                navigate('/login')
            },1000)
            return
        }
        store.clickSource(post._id,scene)
        // v5 数据看板埋点：阅读原文点击 → click_origin。
        // 注意：必须保留用户手势直接同步触发 window.open，否则会被浏览器/微信 WebView
        // 当成异步 popup 拦截。trackView 是 fire-and-forget（fetch 在同步路径内已发出），
        // 不 await，让 window.open 紧跟用户点击事件执行。
        // P-2：透传冗余字段省 backend findById
        trackView(post._id, 'click_origin', undefined, {
          microColumn: post?.microColumn?._id || (typeof post?.microColumn === 'string' ? post.microColumn : undefined),
          category: post?.category?._id || (typeof post?.category === 'string' ? post.category : undefined),
        })
        window.open(url)
    }
    const handleLoadFail=()=>{
        setImgFail(true)
    }
    return (
        <Button
            icon={post.cover&&!imgFail?<img onError={handleLoadFail} src={post.cover} className={styles.cover}/>:<IconLink className={styles.icon}/>}
            size='large'
            target={'_blank'}
            type={'secondary'}
            onClick={handleSourceClick}
            // href={''}
            className={styles.link}>
            {/*<Typography.Paragraph ellipsis={{ rows: 1}}>*/}
            {/*    {text}*/}
            {/*</Typography.Paragraph>*/}
            <div className={styles.content}>
                {isSearchResult?(
                    post.titleHighlightedList?.map((o,i)=>(
                            <span key={i} style={{color:o.highlight?'#ea4335':undefined}}>{o.text}</span>
                        ))
                ):text}
            </div>
        </Button>
    )
})
